import { render, staticRenderFns } from "./PublishingContractsMediaEditPanel.vue?vue&type=template&id=4b964cf4"
import script from "./PublishingContractsMediaEditPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsMediaEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports